import type { RootState } from '@/store';

export const teamSelectedSelector = (state: RootState) => state.team.entities;
